import * as React from 'react';

interface Props {
	fields: { label: string; value: string; }[]
}

export const SummaryTableHeader: React.SFC<Props> = (props: Readonly<Props>): JSX.Element => (
	<span className="summary-table-header">
		{
			props.fields.map(m => (
				<h4 key={m.label}>{m.label}(<b>{m.value}</b>)</h4>
			))
		}
	</span>
);




// WEBPACK FOOTER //
// ./src/app/accounting/shared/summary-table-header.tsx